import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { MutationKeys } from "constants/mutation-keys";
import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const disconnectOpenWidget = async (integrationId: string) => {
  const { error, result } = await ApiManager.integrationsApi.disconnectOpenWidget(integrationId);
  if (error) {
    throw error;
  }
  return result;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useDisconnectOpenWidget = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: [MutationKeys.OpenWidget, "disconnect"],
    mutationFn: disconnectOpenWidget,
    onSuccess: () => {
      queryClient.invalidateQueries(["openWidgetState"]);
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Success,
          content: getToastContent(ToastContent.OPENWIDGET_DISCONNECT_SUCCESS),
        })
      );
    },
    onError: () => {
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Error,
          content: getToastContent(ToastContent.OPENWIDGET_DISCONNECT_FAILURE),
        })
      );
    },
  });
};
